import { motion } from "motion/react";
import { cn } from "../../lib/utils";

const circleStyle = {
  marginLeft: "10px",
  display: "block",
  width: "20px",
  height: "20px",
  border: "4px solid #fff",
  borderTop: "4px solid transparent",
  borderRadius: "50%",
} as const;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: "primary" | "secondary" | "danger";
  isLoading?: boolean;
  disabled?: boolean;
  dataTestId?: string;
}

export default function Button({
  children,
  className,
  variant = "primary",
  isLoading = false,
  disabled = false,
  dataTestId,
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={isLoading || disabled}
      className={cn(
        "h-fit px-4 py-2 rounded-md font-bold box-border cursor-pointer flex items-center justify-center select-none",
        variant === "primary" && "bg-accent text-primary hover:bg-accent-hover",
        variant === "secondary" &&
          "border-0 px-[15px] py-[7px] text-accent hover:text-accent/80 font-medium text-sm",
        variant === "danger" &&
          "bg-red-500/10 text-red-500 hover:bg-red-500/20 border border-red-500/20 font-medium text-sm",
        isLoading && "bg-primary-hover cursor-not-allowed",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      data-testid={dataTestId}
      {...props}
    >
      {children}

      {isLoading ? (
        <motion.span
          style={circleStyle}
          animate={{ rotate: 360 }}
          transition={{
            duration: 0.7,
            repeat: Infinity,
            repeatType: "loop",
            ease: "linear",
          }}
        />
      ) : null}
    </button>
  );
}
